import type {FinishedResponseInteractionService} from 'shared/services';
import type {BarcodeCardSettings} from 'src/features/user/kp-user-barcode-card/types';
import type {WalletBarcodeCardDataService} from 'src/features/user/kp-user-barcode-card/wallet-barcode-card.data-service';

export class WalletBarcodeCardService {
    public static readonly serviceName = 'walletBarcodeCardService';

    /*@ngInject*/
    constructor(private walletBarcodeCardDataService: WalletBarcodeCardDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    public async generateAndDownloadAppleWalletCard(): Promise<void> {
        try {
            await this.walletBarcodeCardDataService.generateAndDownloadAppleWalletCard();
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
        }
    }

    public async generateGoogleWalletCardLink(): Promise<string | null> {
        try {
            return await this.walletBarcodeCardDataService.generateGoogleWalletCardLink();
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            return null;
        }
    }

    public async getCardSettings(): Promise<BarcodeCardSettings | null> {
        try {
            return await this.walletBarcodeCardDataService.getCardSettings();
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            return null;
        }
    }
}